import { passing_draw_line_string as passingMode } from "mapbox-gl-draw-passing-mode";

import { MODE_NAME, PASSING_MODE_NAME } from "./constants";
import splitLineStringMode from "./lineSplit";

const modes = {
  [PASSING_MODE_NAME]: passingMode,
  [MODE_NAME]: splitLineStringMode,
};

export default modes;
